var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOvalInvalid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 10.6165,
    rx: 10,
    ry: 9.83333,
    fill: "#FF7A50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3966 11.144L14.5039 14.2513C14.7943 14.5417 14.7943 14.9967 14.5039 15.2871C14.2135 15.5775 13.7584 15.5775 13.468 15.2871L10.3608 12.1798L7.25356 15.2871C6.96316 15.5775 6.5082 15.5775 6.2178 15.2871C5.9274 14.9967 5.9274 14.5417 6.2178 14.2513L9.32508 11.144L6.2178 8.03676C5.9274 7.74636 5.9274 7.2914 6.2178 7.001C6.5082 6.7106 6.96316 6.7106 7.25356 7.001L10.3608 10.1083L13.468 7.001C13.7584 6.7106 14.2135 6.7106 14.5039 7.001C14.7943 7.2914 14.7943 7.74636 14.5039 8.03676L11.3966 11.144Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvalInvalid);
export default __webpack_public_path__ + "static/media/oval-invalid.8359f49f.svg";
export { ForwardRef as ReactComponent };